export default {
  user: {
    username: '',
    email: ''
  },

  setUser (user) {
    this.user = user
    localStorage.setItem('user', JSON.stringify(this.user))
  },

  getUser () {
    this.user = JSON.parse(localStorage.getItem('user'))
    return this.user
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js